import React from "react";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <React.Fragment>
        <section id="map-grand-canyon-south-rim" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Grand+Canyon+Visitor+Center,+AZ&daddr=Mather+Point,+Grand+Canyon,+AZ+to:Bright+Angel+Trailhead,+Grand+Canyon+Village,+AZ+to:Hermits+Rest,+Grand+Canyon,+AZ+to:Desert+View+Watchtower,+Grand+Canyon,+AZ&output=embed"
            width="100%"
            height="420">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}

export default About;
